import { Location, NavigateFunction } from 'react-router';

import { LEASE_CAR_CONDITION_PARAM_NAME } from 'utils/constants';

/**
 * Adds the condition parameter to the URL search params if it does not already exist, and updates the browser location with the new search parameters.
 * This param has been added (in TMOB-20751) per request from the webanalysts in order to differentiate GA events between new cars and occasions.
 * It is an accepted risk that users can change the value of the query param and thus we do not check for this in the function.
 * @param {URLSearchParams} searchParams - The URL search params.
 * @param {boolean} isOccasion - A boolean indicating if the condition parameter should have the value 'occasion' or 'new'.
 * @param {NavigateFunction} navigate - A function from the react-router library used to update the browser location with the new search parameters.
 * @param {Location} location - The current browser location object.
 * @param {boolean} isFlex - A boolean indicating if the condition parameter should have the value 'flex'.
 * @returns {void}
 */
export const addConditionParam = (
	searchParams: URLSearchParams,
	isOccasion: boolean,
	navigate: NavigateFunction,
	location: Location,
	isFlex: boolean
): void => {
	const conditionParam = searchParams.has(LEASE_CAR_CONDITION_PARAM_NAME);

	if (!conditionParam) {
		searchParams.append(
			LEASE_CAR_CONDITION_PARAM_NAME,
			// eslint-disable-next-line no-nested-ternary
			isFlex ? 'flex' : isOccasion ? 'occasion' : 'new'
		);
		navigate(
			{
				pathname: location.pathname,
				search: searchParams.toString(),
			},
			{ replace: true }
		);
	}
};
